<template>
  <div id="documentacao-index">
    <img src="../../Images/documentacao.jpg" alt="" />
    <p>
      <br /><br />
      <strong>eSUS Feedback</strong><br />
      Rua Estelina Nunes Magalhães, nº 500, Sala 101, Ibiara/PB, inscrita no
      CNPJ/MF sob nº 45.180.436/0001-48. <br />
      Site:
      <a href="https://esusfeedback.com.br" target="_blank"
        >https://esusfeedback.com.br</a
      ><br />
      E-mail:
      <a href="mailto:contato@esusfeedback.com.br"
        >contato@esusfeedback.com.br</a
      ><br />
      Instagram:
      <a href="https://www.instagram.com/biatic" target="_blank"
        >https://www.instagram.com/biatic</a
      >
      <br />
      YouTube:
      <a href="https://www.youtube.com/c/esusfeedback" target="_blank"
        >https://www.youtube.com/c/esusfeedback</a
      ><br />
      WhatsApp/Contato:
      <a
        href="https://api.whatsapp.com/send?phone=5583998414823"
        target="_blank"
        >83 99841-4823</a
      >
      / 83 9 98134-7977
    </p>
    <p>
      <strong>Organização</strong><br />
      Fábio Júnior, Rômulo Rodrigues
    </p>
    <p>
      <strong>Revisão Técnica</strong><br />
      Fábio Júnior
    </p>
    <p><strong>Colaboradores</strong><br /></p>
    <p>
      <strong>Projeto Gráfico</strong><br />
      Tadeu, Diógenes <br />
    </p>
    <p>
      <strong>Referência Bibliográfica</strong> <br />
      ESUS FEEDBACK. DOCUMENTAÇÃO. Rua Estelina Nunes Magalhães, nº 500, Sala
      101, Ibiara/PB. 2023.
      <br />
      ISBN <strong>Versão Preliminar</strong>
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
#documentacao-index {
  margin: 30px;
  img {
    width: 100%;
  }
}
</style>
